import { getCollections } from "../../../api/utils";
import { HeadlineCardsWideSkeleton } from "../skeleton/DesktopSkelton";
import { Link } from "@quintype/components";
import React from "react";
import { timeAgo } from "../../utils/published-date";
import Ads from "../ads/Ads";
import { adUnits } from "../ads/ad-units.js";

export const CardItem = ({ story, index }) => {
  return (
    <Link href={`/${story.story.slug}`}>
      <div className="flex flex-col">
        <div>
          <span className="mb-2 hidden text-xs text-primary md:block"> {story.story.authors[0].name}</span>
          <div className="flex">
            <div>
              <span className="hidden pr-2 font-inter mobile:block">{index + 1}</span>
            </div>
            <h2 className="p-0 text-sm font-[470] leading-[140%] hover:text-[#737275] mobile:text-[0.939rem] mobile:leading-relaxed md:text-base">
              {story.story.headline}
            </h2>
          </div>
        </div>
        <div className="hidden md:block">
          <span className="text-xs text-gray-500">{timeAgo(story.story["content-updated-at"])}</span>
        </div>
      </div>
    </Link>
  );
};

const HeadlineCards = () => {
  const headlineStoriesJson = getCollections("headlines");
  const headlineStoriesItems = headlineStoriesJson?.items?.slice(0, 4) || [];
  if (!headlineStoriesItems || headlineStoriesItems.length === 0) {
    return (
      <div className="p w-[100%] tablet:hidden md:w-[25%] md:px-5">
        <HeadlineCardsWideSkeleton />
      </div>
    );
  }
  return (
    <div className="p w-[100%] tablet:hidden tablet:mobile:block md:w-[25%] md:px-5">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col">
          <Link href={`/section/headlines`}>
            <h1 className="text-xl font-bold text-[#ca4242]">Headlines</h1>
          </Link>
          <hr className="h-[3px] w-[20%] border-none bg-primary" />
        </div>
        <div className="flex flex-col mobile:gap-[24px] md:gap-[16px]">
          {headlineStoriesItems.map((item, i) => (
            <CardItem story={item} key={item.id} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export const HeadlineCardsWide = ({ sectionName, title, slug }) => {
  const headlineStoriesItems = sectionName;
  if (headlineStoriesItems.length === 0) {
    return (
      <div className="p w-[100%] md:w-[35%] md:px-5">
        <HeadlineCardsWideSkeleton />
      </div>
    );
  }
  return (
    <div className="p w-[100%] md:w-[35%] md:px-5">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col">
          <Link href={`/section/${slug || title}`}>
            <h2 className="text-xl font-medium capitalize text-[#ca4242]">{title}</h2>
          </Link>
          <hr className="h-[3px] w-[10%] border-none bg-primary" />
        </div>
        <div className="flex flex-col mobile:gap-[24px] md:gap-[16px]">
          {title == "Infrastructure"
            ? headlineStoriesItems.slice(0, 2).map((item, i) => <CardItem story={item} key={item.id} index={i} />)
            : headlineStoriesItems.map((item, i) => <CardItem story={item} key={item.id} index={i} />)}
          {/* Highlight ads area with a border and background for demo purposes */}
          {title == "Infrastructure" && (
            <div className="p-2 mb-4 w-[300px] h-[250px] ">
              <Ads adunit={adUnits["desktop-hp-right-300x250"]} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeadlineCards;
